import { Grid, Select, MenuItem } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useState } from "react";

interface props {
  items: any[];
  perPageValues?: [number, number, number];
  maxHeight?: number;
}

const GridContainerPagination = ({
  items,
  perPageValues,
  maxHeight,
}: props) => {
  const perPageValuesAux = [8, 16, 24];
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(
    perPageValues ? perPageValues[0] : perPageValuesAux[0]
  );

  const itemsToShow = items.slice((page - 1) * perPage, page * perPage);

  return (
    <Grid container>
      <Grid
        item
        container
        spacing={3}
        style={{
          maxHeight: maxHeight,
          overflow: "auto",
          padding: "0px 15px",
        }}
      >
        {itemsToShow.map((item, index) => (
          <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
            {item}
          </Grid>
        ))}
      </Grid>
      <Grid
        item
        container
        xs={12}
        justifyContent="flex-end"
        alignItems="center"
        spacing={2}
        style={{ paddingTop: 20 }}
      >
        <Grid item>
          <div>
            <span>Registros a mostrar:&nbsp;</span>
            <Select
              variant="outlined"
              onChange={({ target }) => setPerPage(Number(target.value))}
              defaultValue={perPage}
              value={perPage}
            >
              {perPageValues
                ? perPageValues.map((p) => (
                    <MenuItem key={p} value={p}>
                      {p}
                    </MenuItem>
                  ))
                : perPageValuesAux.map((p) => (
                    <MenuItem key={p} value={p}>
                      {p}
                    </MenuItem>
                  ))}
            </Select>
          </div>
        </Grid>
        <Grid item>
          <Pagination
            onChange={(_, page) => setPage(page)}
            count={
              Math.ceil(items.length / perPage) === 0
                ? 1
                : Math.ceil(items.length / perPage)
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default GridContainerPagination;
